// TODO: Double check and rewrite it using URL if possible
export const getDomainName = (url: string): string | undefined => {
  const m = url.match(/^(https?:\/\/)?([^/]+)/);
  return m ? m[2] : undefined;
};

export const hasSchema = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const addSchemaIfEmpty = (url: string, defaultSchema: string = "https"): string => {
  if (hasSchema(url)) {
    return url;
  }

  return `${defaultSchema}://${url}`;
};

export const parseUrl = (url: string): undefined | URL => {
  try {
    return new URL(url);
  } catch {
    return undefined;
  }
};

export const isValidUrl = (url: string): boolean => {
  return !!parseUrl(addSchemaIfEmpty(url));
};

export const removeSchemaFromUrl = (url: string) => url.replace(/^https?:\/\//, "");
